(function(){
  /* data-product-id may name more than one product, comma separated, so a page
     can show the reviews for every format of the same book. The endpoint wants
     the parameter repeated once per id: a comma-separated value is rejected
     with a 400, and -- the reason this is spelled out -- `product_ids[]` is
     accepted but silently ignores the filter and returns every review in the
     shop. */
  function idsOf(region){
    return String(region.dataset.productId||'').split(',').map(function(id){
      return id.trim();
    }).filter(Boolean);
  }
  /* A review that does not describe the book yet -- "haven't read it yet", or a
     couple of words sitting next to a star rating -- is a poor thing to open a
     sales page with, however recent it is. Regions marked data-lead-with-reviews
     move those to the back instead of leading with them. Nothing is dropped:
     the rating is real and the count above the carousel still has to add up.
     Testing for `read` or `started` sitting near `yet`, in either order, catches
     the usual phrasings without depending on how "haven't" was spelled. It is
     deliberately no broader than that: "can't wait to read the next one" ends
     plenty of genuine reviews, so phrases like it are left alone. */
  var NOT_READ_YET=/\b(read|started)\b[^.!?]{0,24}\byet\b|\byet\b[^.!?]{0,24}\b(read|started)\b/i;
  function weak(review){
    var text=(review.content||'').trim();
    return text.length<40||NOT_READ_YET.test(text);
  }
  document.querySelectorAll('[data-live-reviews]').forEach(function(region){
    var track=region.querySelector('.live-review-track'),status=region.querySelector('.live-review-status'),seen=new Set(),total=0,busy=false,done=false;
    var prev=region.querySelector('.review-prev'),next=region.querySelector('.review-next');
    var ordering=region.hasAttribute('data-lead-with-reviews'),strong=[],rest=[];
    /* The store's own review count for these products, from the rating
     metafield, passed in by the section. It can be larger than the number the
     public feed serves -- older imported reviews are counted in the metafield
     but are not returned by the widget endpoint -- and when it is, the status
     line says so rather than contradicting the rating printed above it. */
  function settled(loaded){
    var claimed=parseInt(region.dataset.ratingCount,10);
    if(isFinite(claimed)&&claimed>loaded){
      return 'Showing '+loaded+' of '+claimed+' customer reviews · Swipe or use the arrows';
    }
    return loaded+' customer reviews · Swipe or use the arrows';
  }
  function move(dir){var card=track.firstElementChild;if(card)track.scrollBy({left:dir*(card.getBoundingClientRect().width+18),behavior:'smooth'});}
    prev.addEventListener('click',function(){move(-1)});next.addEventListener('click',function(){move(1)});
    function controls(){prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;}
    track.addEventListener('scroll',controls,{passive:true});window.addEventListener('resize',controls);
    function add(review){
      if(seen.has(review.id))return;seen.add(review.id);
      var card=document.createElement('article');card.className='live-review-card';card.setAttribute('role','group');card.setAttribute('aria-label','Review '+seen.size);
      var stars=document.createElement('div'),rating=Math.max(1,Math.min(5,Number(review.star)||1));stars.className='live-review-stars';stars.textContent='★'.repeat(rating)+'☆'.repeat(5-rating);stars.setAttribute('aria-label',rating+' out of 5 stars');
      var content=document.createElement('p');content.className='live-review-text';content.textContent=review.content||'This reader left a star rating.';content.tabIndex=0;
      var author=document.createElement('p');author.className='live-review-author';author.textContent=review.author||'Reader';
      var meta=document.createElement('p');meta.className='live-review-meta';var date=new Date(review.created_at);meta.textContent=(review.verified_purchase?'Verified purchase · ':'')+(!isNaN(date)?date.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}):'');
      card.append(stars,content,author,meta);track.append(card);
      if(ordering)(weak(review)?rest:strong).push(card);
    }
    /* Re-appending a node already in the track moves it, so the order settles
       after every batch without rebuilding a card. Feed order is newest-first
       and a stable partition keeps that inside each group. */
    function reorder(){
      strong.concat(rest).forEach(function(card,i){
        card.setAttribute('aria-label','Review '+(i+1));track.append(card);
      });
    }
    async function load(){
      if(busy||done)return;busy=true;var after='';
      try{
        while(!done){
          var url=new URL('https://pub.kudosi.ai/storefront/reviews');url.searchParams.set('shop_domain','authoranne-mariemeyer.myshopify.com');idsOf(region).forEach(function(id){url.searchParams.append('product_ids',id)});url.searchParams.set('widget_type','review_box');url.searchParams.set('sort_by','created_at');url.searchParams.set('sort_order','desc');if(after)url.searchParams.set('after_review_id',after);
          var response=await fetch(url.toString(),{credentials:'omit'});if(!response.ok)throw new Error('Review feed unavailable');var data=await response.json(),reviews=data.reviews||[],before=seen.size;total=Number(data.total_reviews)||total;reviews.forEach(add);if(ordering)reorder();
          done=!data.has_more||!reviews.length||seen.size===before;after=reviews.length?reviews[reviews.length-1].id:'';
          status.textContent=done?settled(seen.size):(seen.size+' of '+total+' reviews loaded · Loading more…');controls();
        }
        if(!seen.size)status.textContent='No customer reviews yet.';
      }catch(error){status.textContent=seen.size?'More reviews could not load. View all reviews in the store below.':'Reviews are temporarily unavailable. View all reviews in the store below.';done=false;}
      busy=false;
    }
    if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting})){observer.disconnect();load();}},{rootMargin:'600px'});observer.observe(region);}else load();
    controls();
  });
})();
